import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { states } from '../utils/data.js'
import ArrowDown from '../assets/arrow_down.svg'
import { useStore } from '../store/store.js';
import { proceedCheckOut } from '../utils/actions.js';
import { useNavigate } from 'react-router-dom';
import { appRoutes } from '../utils/app_routes.js';

const Checkout = () => {

    const cartItem = localStorage.getItem('cart-product');
    const { state: { products, myAddress } } = useStore()
    const [sub2Val, setSub2Val] = useState("123456");
    const { register, handleSubmit, formState: { errors }, watch, setValue, } = useForm();
    const navigate = useNavigate();

    const handleZipCodeChange = (e) => {
        let value = e.target.value.replace(/\D/g, '');
        if (value.length > 5) {
            value = `${value.slice(0, 5)}-${value.slice(5, 9)}`;
        }
        setValue('zip_code', value, { shouldValidate: true });
    };

    const handlePhoneChange = (e) => {
        let value = e.target.value.replace(/\D/g, '');

        if (value.length > 10) {
            value = value.slice(0, 10);
        }
        if (value.length > 6) {
            value = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6)}`;
        } else if (value.length > 3) {
            value = `(${value.slice(0, 3)}) ${value.slice(3)}`;
        } else if (value.length > 0) {
            value = `(${value}`;
        }
        setValue('phone', value, { shouldValidate: true });
    };
    const phone = watch("phone", '');

    const zipCode = watch('zip_code', "");

    useEffect(() => {
        if (myAddress) {
            let zipCode = myAddress.postal.code
            let city = myAddress.city.names.en
            const state = myAddress.country.iso_code
            if (zipCode.length > 5) {
                zipCode = `${zipCode.slice(0, 5)}-${zipCode.slice(5, 9)}`;
            }
            setValue('zip_code', zipCode, { shouldValidate: true });
            setValue('city', city, { shouldValidate: true });
            setValue('state', state, { shouldValidate: true })
        }
    }, [myAddress])

    useEffect(() => {
        if (sub2Val) {
            try {
                const viewAPI = async () => {
                    await fetch("http://192.168.1.18:3001/view", {
                        body: JSON.stringify({ url: `${sub2Val}` }),
                        method: "POST",
                        headers: { "Content-Type": "application/json" }
                    });
                }
                // viewAPI()
            } catch (err) {
                // console.log("view err", err)
            }
        }
        const ar = [1, 2, 3, 4, 5, 65]
        ar.reverse()
        console.log(ar)
    }, [sub2Val])

    const submitHandler = async (data) => {
        const product = products.find(i => i.productName === (cartItem || "5_bottles_bundle"));
        const importLeadCountry = process.env.REACT_APP_API_COUNTRY;
        const importLeadCampaignId = process.env.REACT_APP_API_CAMPAIGN_ID;
        const productQty = process.env.REACT_APP_API_PRODUCT_QTY;
        const formattedNumber = data.phone.replace(/\D/g, "");
        data = {
            firstName: data.first_name,
            lastName: data.last_name,
            address1: data.address,
            address2: data.additional_address,
            postalCode: data.zip_code,
            city: data.city,
            state: data.state,
            country: importLeadCountry,
            emailAddress: data.emailAddress,
            phoneNumber: formattedNumber,
            shipFirstName: data.first_name,
            shipLastName: data.last_name,
            shipAddress1: data.address,
            shipAddress2: data.address2,
            shipPostalCode: data.zip_code,
            shipCity: data.city,
            shipState: data.state,
            shipCountry: importLeadCountry,
            custom1: sub2Val,
            campaignId: importLeadCampaignId,
            sourceValue1: sub2Val
        }
        const parsedData = Object.keys(data).map(key => key + '=' + data[key]).join('&')
        const response = await proceedCheckOut(parsedData)
        if (response) {
            sessionStorage.setItem("regFormValues", JSON.stringify({
                ...data,
                customerId: response.customerId,
                product1_id: product.productId,
                product1_qty: productQty,
                product1_price: product.price
            }));
            navigate(appRoutes.payment)
        }
    }

    return (
        <div className='py-4 md:py-[100px] px-[4%] sm:px-[6%] xl:px-[10%] 2xl:px-[12.6%] flex flex-col-reverse md:flex-row gap-[30px] w-full border'>
            <form onSubmit={handleSubmit(submitHandler)} className='w-full px-4 py-8 md:px-[60px] md:py-10 bg-[#F3FCEF] text-start select-none'>
                <div>
                    <p className='text-[20px] font-semibold leading-[30px] text-start mb-[10px]'>Contact</p>
                    <input
                        type="email"
                        {...register('emailAddress', {
                            required: 'Email is required',
                            pattern: {
                                value: /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/,
                                message: 'Invalid email address'
                            }
                        })}
                        className='outline-none bg-white w-full border border-[#00000040] px-4 md:px-6 py-[9px] rounded-[4px] text-secondary text-[14px] leading-6 font-normal'
                        placeholder='Email'
                        autoComplete='false'
                    />
                    {errors.emailAddress && <span className="text-red-500 text-xs">{errors.emailAddress.message}</span>}
                    {/* Custom check box */}
                    <div className="flex items-center mt-4 gap-[6px]">
                        <input
                            type="checkbox"
                            id="custom-checkbox"
                            className="hidden peer"
                        />
                        <label
                            htmlFor="custom-checkbox"
                            className="w-[18px] h-[18px] flex items-center justify-center border border-primary rounded-[2px] cursor-pointer peer-checked:bg-primary transition"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M12.5598 4.24703L5.55977 11.247C5.51914 11.2877 5.47089 11.32 5.41778 11.342C5.36467 11.364 5.30774 11.3753 5.25024 11.3753C5.19275 11.3753 5.13582 11.364 5.08271 11.342C5.0296 11.32 4.98134 11.2877 4.94071 11.247L1.87821 8.18453C1.79612 8.10244 1.75 7.9911 1.75 7.875C1.75 7.7589 1.79612 7.64756 1.87821 7.56547C1.9603 7.48337 2.07165 7.43726 2.18774 7.43726C2.30384 7.43726 2.41518 7.48337 2.49727 7.56547L5.25024 10.319L11.9407 3.62797C12.0228 3.54587 12.1341 3.49976 12.2502 3.49976C12.3663 3.49976 12.4777 3.54587 12.5598 3.62797C12.6419 3.71006 12.688 3.8214 12.688 3.9375C12.688 4.0536 12.6419 4.16494 12.5598 4.24703Z" fill="white" />
                            </svg>
                        </label>
                        <span className="text-[12px] leading-[22px] font-medium text-secondary">
                            Email me with news and offers
                        </span>
                    </div>
                </div>
                <div className='mt-5 md:mt-10'>
                    <p className='text-[20px] font-semibold leading-[30px] text-start mb-[10px]'>Shipping Address</p>
                    <div className='mt-5'>
                        <div className='relative'>
                            <select
                                {...register('state', { required: 'State is required' })}
                                defaultValue=''
                                className='w-full bg-white border border-[#00000040] outline-none px-4 md:px-6 py-[9px] rounded-[4px] text-secondary text-[14px] leading-6 font-normal appearance-none relative'
                            >
                                <option value="" disabled>Country States</option>
                                {
                                    states.map((state, inx) => (
                                        <option key={inx} value={state.value}>{state.label}</option>
                                    ))
                                }
                            </select>
                            <img src={ArrowDown} alt="ArrowDown" className='absolute top-1/2 -translate-y-1/2 right-4 md:right-6 pointer-events-none' />
                        </div>
                        {errors.state && <span className="text-red-500 text-xs">{errors.state.message}</span>}
                    </div>
                    <div className='w-full flex flex-col md:flex-row gap-5 mt-5'>
                        <div className='w-full'>
                            <input
                                type="text"
                                {...register('first_name', { required: 'First name is required' })}
                                placeholder='First Name'
                                className='outline-none capitalize bg-white w-full border border-[#00000040] px-4 md:px-6 py-[9px] rounded-[4px] text-secondary text-[14px] leading-6 font-normal'
                            />
                            {errors.first_name && <span className="text-red-500 text-xs">{errors.first_name.message}</span>}
                        </div>
                        <div className='w-full'>
                            <input
                                type="text"
                                {...register('last_name', { required: 'Last name is required' })}
                                placeholder='Last Name'
                                className='outline-none capitalize bg-white w-full border border-[#00000040] px-4 md:px-6 py-[9px] rounded-[4px] text-secondary text-[14px] leading-6 font-normal'
                            />
                            {errors.last_name && <span className="text-red-500 text-xs">{errors.last_name.message}</span>}
                        </div>
                    </div>
                    <input
                        type="text"
                        {...register('address', { required: 'Address is required' })}
                        placeholder='Address'
                        className='outline-none bg-white w-full border border-[#00000040] px-4 md:px-6 py-[9px] rounded-[4px] text-secondary text-[14px] leading-6 font-normal mt-5'
                    />
                    {errors.address && <span className="text-red-500 text-xs">{errors.address.message}</span>}
                    <input
                        type="text"
                        {...register('additional_address')}
                        placeholder='Apartment, Suite, etc. (optional)'
                        className='outline-none bg-white w-full border border-[#00000040] px-4 md:px-6 py-[9px] rounded-[4px] text-secondary text-[14px] leading-6 font-normal mt-5'
                    />
                    <div className='w-full flex flex-col md:flex-row gap-5 mt-5'>
                        <div className='w-full'>
                            <input
                                type="text"
                                {...register('city', { required: 'City is required' })}
                                placeholder='City'
                                className='outline-none bg-white w-full border border-[#00000040] px-4 md:px-6 py-[9px] rounded-[4px] text-secondary text-[14px] leading-6 font-normal'
                            />
                            {errors.city && <span className="text-red-500 text-xs">{errors.city.message}</span>}
                        </div>
                        <div className='w-full'>
                            <input
                                type="text"
                                value={zipCode}
                                {...register('zip_code', {
                                    required: 'ZIP Code is required',
                                    pattern: {
                                        value: /^\d{5}(-\d{4})?$/,
                                        message: 'Invalid ZIP Code'
                                    }
                                })}
                                onChange={handleZipCodeChange}
                                placeholder='ZIP Code'
                                className='outline-none bg-white w-full border border-[#00000040] px-4 md:px-6 py-[9px] rounded-[4px] text-secondary text-[14px] leading-6 font-normal'
                            />
                            {errors.zip_code && <span className="text-red-500 text-xs">{errors.zip_code.message}</span>}
                        </div>
                    </div>
                    <input
                        type="text"
                        value={phone}
                        {...register("phone", {
                            required: "Phone number is required",
                            validate: (value) =>
                                /^\(\d{3}\) \d{3}-\d{4}$/.test(value) || "Invalid phone number",
                        })}
                        onChange={handlePhoneChange}
                        placeholder='Phone'
                        className='outline-none appearance-none bg-white w-full border border-[#00000040] px-4 md:px-6 py-[9px] rounded-[4px] text-secondary text-[14px] leading-6 font-normal mt-5'
                    />
                    {errors.phone && <span className="text-red-500 text-xs">{errors.phone.message}</span>}
                    {/* Custom check box */}
                    <div className="flex items-center mt-4 gap-[6px]">
                        <input
                            type="checkbox"
                            id="custom-checkbox-2"
                            className="hidden peer"
                        />
                        <label
                            htmlFor="custom-checkbox-2"
                            className="w-[18px] h-[18px] flex items-center justify-center border border-primary rounded-[2px] cursor-pointer peer-checked:bg-primary transition"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M12.5598 4.24703L5.55977 11.247C5.51914 11.2877 5.47089 11.32 5.41778 11.342C5.36467 11.364 5.30774 11.3753 5.25024 11.3753C5.19275 11.3753 5.13582 11.364 5.08271 11.342C5.0296 11.32 4.98134 11.2877 4.94071 11.247L1.87821 8.18453C1.79612 8.10244 1.75 7.9911 1.75 7.875C1.75 7.7589 1.79612 7.64756 1.87821 7.56547C1.9603 7.48337 2.07165 7.43726 2.18774 7.43726C2.30384 7.43726 2.41518 7.48337 2.49727 7.56547L5.25024 10.319L11.9407 3.62797C12.0228 3.54587 12.1341 3.49976 12.2502 3.49976C12.3663 3.49976 12.4777 3.54587 12.5598 3.62797C12.6419 3.71006 12.688 3.8214 12.688 3.9375C12.688 4.0536 12.6419 4.16494 12.5598 4.24703Z" fill="white" />
                            </svg>
                        </label>
                        <span className="text-[12px] leading-[22px] font-medium text-secondary select-none">
                            Get an EXTRA 10% OFF your next order just by opting into text-message updates
                        </span>
                    </div>
                </div>
                <div className='w-full flex justify-start select-none'>
                    <button className='mt-5 md:mt-10 inline-block btn-primary text-start' type='submit'>Continue To Checkout</button>
                </div>
            </form>
            <div className='w-full text-start'>
                {products.filter(i => i.productName === (cartItem || '5_bottles_bundle')).map((p, inx) => (
                    <div className='flex flex-col gap-3 md:gap-6' key={inx}>
                        <div className='flex justify-between '>
                            <div className='flex gap-5'>
                                <div className='h-[125px] aspect-square bg-[#F0F0F0] p-4 rounded-[4.288px] flex justify-center'>
                                    <img src={p.productImagePath} alt="productImagePath" className='h-24' />
                                </div>
                                <div>
                                    <p className='text-[20px] font-semibold leading-[30px]'>{p.productName.replaceAll('_', ' ')}</p>
                                    <p className='text-[16px] font-normal leading-[26px] text-secondary'>{p.productQty} Bottles</p>
                                </div>
                            </div>
                            <div>
                                <p className='text-[20px] font-semibold leading-[30px]'>${p.price}</p>
                                <p className='text-[16px] font-normal leading-[26px] text-secondary text-end line-through'>${p.msrp}</p>
                            </div>
                        </div>
                        <div className='flex justify-between text-[18px] font-semibold leading-[28px] text-primary'>
                            <p>Total Savings</p>
                            <p>-${(p.msrp - p.price).toFixed(2)}</p>
                        </div>
                        <div className='flex justify-between text-[18px] font-medium leading-[28px] text-secondary '>
                            <p>Sub Total</p>
                            <p>${p.price}</p>
                        </div>
                        <div className='flex justify-between text-[18px] font-medium leading-[28px] text-secondary'>
                            <p>Shipping</p>
                            <p>Calculated at next step</p>
                        </div>
                        <div className='flex justify-between '>
                            <p className='text-[20px] font-bold leading-[28px]'>Total</p>
                            <p className='text-[18px] font-medium leading-[28px]'>USD ${p.price}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Checkout;
